import { SheetField } from '../types';

export const getCurrentField = (fieldsList: SheetField[], focusedFieldName: string | null) => {
    const fieldIndex = fieldsList.findIndex((item) => item.name === focusedFieldName);

    return fieldIndex !== -1
        ? {
              index: fieldIndex,
              field: fieldsList[fieldIndex],
          }
        : {
              index: fieldIndex,
              field: null,
          };
};
